import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import { palette, typography } from "../../theme/brand";

// Reusable centered section wrapper with an optional title/subtitle. Replaces the
// ad-hoc Grid + template `title` classes previously used by AboutUs sections.
const styles = {
  section: {
    padding: "70px 0"
  },
  header: {
    textAlign: "center",
    maxWidth: "760px",
    margin: "0 auto 50px"
  },
  title: {
    color: palette.textPrimary,
    fontFamily: typography.fontFamilyDisplay,
    fontWeight: 700,
    fontSize: "2.25rem",
    margin: "0 0 12px"
  },
  subtitle: {
    color: palette.textSecondary,
    fontFamily: typography.fontFamilyBase,
    fontSize: "1.05rem",
    lineHeight: 1.6,
    margin: 0
  }
};

function Section({ classes, title, subtitle, children }) {
  return (
    <section className={classes.section}>
      {(title || subtitle) && (
        <div className={classes.header}>
          {title && <h2 className={classes.title}>{title}</h2>}
          {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
        </div>
      )}
      {children}
    </section>
  );
}

Section.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node
};

export default withStyles(styles)(Section);



// WEBPACK FOOTER //
// ./src/components/ui/Section.jsx